import { FunctionField } from 'react-admin';
import { faDiagramSubtask } from '@fortawesome/pro-regular-svg-icons';
import get from 'lodash/get';
import { Container, Icon, IconWrapper, Version } from './styled';
import { CriminalVersionFieldProps } from './types';

const CriminalVersionField = ({
  label = 'Criminal Version',
  onClick,
  sortable,
  source,
  ...props
}: CriminalVersionFieldProps) => {
  return (
    <FunctionField
      label={label}
      sortable={sortable}
      source={source}
      render={(record) => {
        const criminalVersion = get(record, source);
        const isV6 = Number(criminalVersion) >= 6;
        return (
          <Container>
            <Version>{criminalVersion}</Version>
            {isV6 && (
              <IconWrapper onClick={() => onClick?.(record)}>
                <Icon icon={faDiagramSubtask} />
              </IconWrapper>
            )}
          </Container>
        );
      }}
      {...props}
    />
  );
};

export default CriminalVersionField;
